const state = {
  isLoading: true,
  isAuthenticated: false,
  settings: {},
  user: {},
  currentCompanyId: null,
  abilities: []
}

export default state
